import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10245f03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 mt-1" }, "\n            規定の給与と変更後の給与の差額を確認し、勤怠変更を申請してください。\n          ")
], -1))
const _hoisted_3 = { class: "bg-white border border-outline-color p-3 round-4" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "勤務時間", -1))
const _hoisted_6 = { class: "text-mild text-size-14" }
const _hoisted_7 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "休憩時間", -1))
const _hoisted_9 = {
  key: 0,
  class: "text-mild text-size-14"
}
const _hoisted_10 = {
  key: 1,
  class: "text-mild text-size-14"
}
const _hoisted_11 = { class: "bg-white border border-outline-color p-3 mt-3 round-4" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "規定の給与", -1))
const _hoisted_14 = { class: "text-mild text-size-14" }
const _hoisted_15 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1))
const _hoisted_17 = { class: "text-mild text-size-14" }
const _hoisted_18 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "規定額合計", -1))
const _hoisted_20 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_21 = { class: "d-flex justify-content-between border-top border-outline-color mt-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-2" }, "変更後の給与", -1))
const _hoisted_23 = { class: "text-mild text-size-14 mt-2" }
const _hoisted_24 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1))
const _hoisted_26 = { class: "text-mild text-size-14" }
const _hoisted_27 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "変更申請額合計", -1))
const _hoisted_29 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_30 = { class: "d-flex justify-content-between border-top border-outline-color mt-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500 mt-2" }, "差額", -1))
const _hoisted_32 = { class: "text-blue text-size-16 text-weight-500 mt-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "\n              報酬額が9300円以上(交通費除く)の場合、別途源泉所得税が控除されます\n            ")
], -1))
const _hoisted_34 = { class: "mt-3" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "p-3 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_TextAreaGroup = _resolveComponent("TextAreaGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      勤怠変更差額確認\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.application)
      ? (_openBlock(), _createBlock(_component_ApplicationCard, {
          key: 0,
          application: _ctx.application,
          class: "mt-3 mx-3 mb-2"
        }, null, 8, ["application"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, null, {
      default: _withCtx(({ handleSubmit }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.actualWorkStartAt) + "-" + _toDisplayString(_ctx.actualWorkEndAt), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(),
              (_ctx.actualRestStartAt && _ctx.actualRestEndAt)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.actualRestStartAt) + "-" + _toDisplayString(_ctx.actualRestEndAt), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, "\n              休憩無し\n            "))
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_14, "\n              ¥\n              " + _toDisplayString(_ctx.formatNumber(_ctx.salaryPerDay)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_17, "\n              ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_20, "\n              ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.salaryPerDay + _ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_23, "\n              ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.actualSalaryPerDay)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_26, "\n              ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_29, "\n              ¥\n              " + _toDisplayString(_ctx.formatNumber(_ctx.actualSalaryPerDay + _ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_32, "\n              ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.differenceSalaryPerDay)), 1)
            ]),
            _createTextVNode(),
            _hoisted_33
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_ValidationProvider, {
              name: "コメント",
              rules: { required: true, max: 2000 },
              vid: "comment"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(_component_TextAreaGroup, {
                  modelValue: _ctx.comment,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
                  label: "コメント",
                  appLabelText: "必須",
                  placeholder: "出勤時間から遅れてしまいましたので勤怠修正お願いします。",
                  validationState: validationState,
                  class: "mt-1"
                }, null, 8, ["modelValue", "validationState"])
              ]),
              _: 1
            })
          ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_AppCheckbox, {
            modelValue: _ctx.isCheckedAmount,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCheckedAmount) = $event)),
            id: "contacted",
            text: "報酬の差額を確認しました",
            class: "cancel-check-box"
          }, null, 8, ["modelValue"])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_AppButton, {
            variant: "secondary",
            block: true,
            disabled: !_ctx.comment || !_ctx.isCheckedAmount,
            onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton))
          }, {
            default: _withCtx(() => [
              _createTextVNode("勤怠変更申請を提出する")
            ], undefined, true),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          _createTextVNode(),
          _createVNode(_component_AppButtonOutline, {
            onClick: _ctx.onClickBack,
            block: true,
            class: "d-block mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          入力画面に戻る\n        ")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}